import { render, staticRenderFns } from "./lnk-lov-radio.vue?vue&type=template&id=38f36017&"
import script from "./lnk-lov-radio.vue?vue&type=script&lang=js&"
export * from "./lnk-lov-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports